<template>
  <div class="h-full">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style></style>
